"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JoinType;
(function (JoinType) {
    JoinType["INNER"] = "INNER";
    JoinType["LEFT_OUTER"] = "LEFT_OUTER";
    JoinType["RIGHT_OUTER"] = "RIGHT_OUTER";
    JoinType["FULL_OUTER"] = "FULL_OUTER";
})(JoinType || (JoinType = {}));
exports.default = JoinType;
//# sourceMappingURL=JoinType.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/JoinType.js
// module id = 1579
// module chunks = 8